import stats from './stats'
import * as R from 'ramda'

export default function addLoggingToDispatch(store) {
	const next = store.dispatch
	if (!console.group) {
		return next
	}
	return action => {
		let log = action.type != 'SCROLL'
		if (log) {
			// console.groupCollapsed(action.type)
			console.group(action.type)
			var prevState = store.getState()
			console.log('%cprev state', 'color: gray', prevState)
			console.log('%caction', 'color: blue', action)
			var t1 = new Date()
		}
		const returnValue = next(action)
		if (log) {
			let nextState = store.getState()
			console.log('%cnext state', 'color: green', nextState)
			if (prevState.data.db != nextState.data.db) {
				console.warn('DB CHANGED', !R.equals(prevState.data.db, nextState.data.db))
			}
			let time = new Date() - t1
			let ss = stats.all()
			ss = R.filter(x => x.time > 9, ss)
			ss = R.map(x => x.time + (x.recomputations > 1 ? ' ('+x.recomputations+')' : ''), ss)
			console.log(time+'ms', ss)
			stats.clear()
			console.groupEnd(action.type)
		}
		return returnValue
	}
}



// WEBPACK FOOTER //
// ./src/utils/redux/addLoggingToDispatch.js